import { engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Symbol } from "../GameComponents/Symbol";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { PlayList } from "../Components/Sounds/PlayList";
import { BetManager } from "../Managers/BetManager";
import { Payline } from "../GameComponents/Payline";
import { ModuleManager } from "../Managers/ModuleManager";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { Languages } from "../Utils/Languages";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";
import { DataManager } from "../Managers/DataManager";
import { BaseView } from "../GameComponents/Base/BaseView";
import { ImageTextElement } from "../Components/Elements/Texts/ImageTextElement";
import { GameManager } from "../Managers/GameManager";
import { FreespinsView } from "../GameComponents/Freespins/FreespinsView";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimator2 extends WinAnimator {
    static Line1: number = 0xff0000;

    static Force: boolean = false;

    public oldBaseValue: string = "0";
    public specialValue: string = "0";

    protected scatterCounter: number = 0;
    protected scatter: FrameTimerEventEmitter;
    protected scatterFS: FrameTimerEventEmitter;

    protected scatterWin: Communication.Game.IWin;
    protected scatterSymbols: Array<Symbol> = [];
    protected scatterFsSymbols: Array<Symbol> = [];
    protected scatterFsSymbolsValues: Array<number> = [];

    protected wasExtraScatters: boolean = false;
    protected extraScatterCounter: number = 0;
    protected extraScatter: FrameTimerEventEmitter;
    protected extraScatterSound: FrameTimerEventEmitter;
    protected extraScatterSound1: FrameTimerEventEmitter;
    protected extraScatterSymbols: Array<Symbol> = [];

    protected createTimer(): void {
        super.createTimer();
        this.scatter = CreateFrameTimer("scatter");
        this.scatter.on(FrameTimerEvents.Complete, this.onScatter.bind(this));
        this.scatterFS = CreateFrameTimer("scatterFS");
        this.scatterFS.on(FrameTimerEvents.Complete, this.onFSScatter.bind(this));
        this.extraScatter = CreateFrameTimer("extraScatter");
        this.extraScatter.on(FrameTimerEvents.Complete, this.onExtraScatter.bind(this));
        this.extraScatterSound = CreateFrameTimer("extraScatterSound");
        this.extraScatterSound.on(FrameTimerEvents.Complete, this.onExtraScatterSound.bind(this));
        this.extraScatterSound1 = CreateFrameTimer("extraScatterSound1");
        this.extraScatterSound1.on(FrameTimerEvents.Complete, this.onExtraScatterSound1.bind(this));
    }

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        super.onReelStopped(reelsData, reelIndex);

        if (Symbol.Teas) {
            for (let i: number = 0; i < this.currentSymbols.length; i++) {
                for (let j: number = 0; j < this.currentSymbols[i].length; j++) {
                    if (this.currentSymbols[i][j] != null && this.currentSymbols[i][j].id < 8) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseNowin);
                        this.noWinSymbolsContainer.addChild(this.currentSymbols[i][j]);
                    }
                }
            }
        }

        // let calcScatters: number = 0;
        // for(let i: number = 0; i <= reelIndex; i++) {
        //     for(let j: number = 0; j < this.currentSymbols[i].length; j++) {
        //         if(this.currentSymbols[i][j].id === 8) {
        //             calcScatters++;
        //         }
        //     }
        // }

        for (let i: number = 0; i < this.currentSymbols[reelIndex].length; i++) {
            if (this.currentSymbols[reelIndex][i].id === 8) {
                PlayList.play("SND_BaseScatter0" + reelIndex);
                this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseImpact);
            }
            if (this.currentSymbols[reelIndex][i].id === 9) {
                PlayList.play("SND_FSScatter0" + reelIndex);
                this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseImpact);
            }
        }

        this.moveToTop();
    }

    public showSymbols(reelsData: Array<Communication.Game.IReel>): void {
        super.showSymbols(reelsData);
        this.moveToTop();
    }

    protected finishFirstWins(): void {
        this.emit(WinAnimator.FinishWinAnimator);

        if (this.currentWins && this.currentWins.length > 0) {
            //if scatter win, we get 2 wins (cash, fs) - still single win
            if (this.currentWins[0].trigger == Communication.Game.WinTrigger.Scatter && this.currentWins.length == 2) {
                this.winSymbolsGoToCase(0, Symbol.CaseWin, true);
                PlayList.play("SND_BaseRecapWinline");

                if (!ModuleManager.freespinsEnabled() && !ModuleManager.freespinsActive()) {
                    PlayList.loop("SND_BaseRecapLoop");
                }

                return;
            }

            this.stopTimer();
            this.currentCycle = 0;
            this.cycleWins(true);
        }
    }

    public showInitWins(wins: Array<Communication.Game.IWin>, win: number): void {
        this.currentWins = wins;
        this.currentWin = win;

        this.customTints();
        this.resetAnimations();

        if (wins != null && wins.length > 0) {
            this.showCustomInitWin();
            this.showFirstInitWins();
            this.finishFirstInitWins();
            this.moveToTop();
        } else {
            this.resetAmountsOnSymbols();
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
            this.moveToTop();
        }
        this.reAppendSymbols();
    }

    public showWins(wins: Array<Communication.Game.IWin>, win: number): boolean {
        this.currentWins = wins;
        this.currentWin = win;
        this.scatterFsSymbols = [];
        this.scatterFsSymbolsValues = [];

        SwitchElement.CustomCase = "BACKGROUND_0";
        this.customTints();
        this.customWildBackground();
        this.resetAnimations();

        if (wins != null && wins.length > 0) {
            this.currentMultiplierIndex = 0;

            for (let i = 0; i < this.multipliers.length; i++) {
                if (this.currentWin / BetManager.Bet >= this.multipliers[i]) {
                    this.currentMultiplierIndex = i;
                }
            }

            if (wins.length === 1 && win === 0) {
                this.currentMultiplierIndex = 6;
            }

            if (!this.showCustomWin()) {
                this.playWildSounds();
                this.showFirstWins();
            }
            this.moveToTop();
            return this.currentMultiplierIndex >= 3;
        } else {
            this.resetAmountsOnSymbols();
            this.allSymbolsGoToCase(Symbol.CaseNormal, false);
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
            this.moveToTop();
            return false;
        }
    }

    protected showFirstInitWins(): void {
        this.allSymbolsGoToCase(Symbol.CaseNowin, true);
        this.allPaylinesGoToCase(Payline.CaseNowin);

        for (let i = 0; i < this.currentWins.length; i++) {
            if (this.currentWins[i].trigger == Communication.Game.WinTrigger.Scatter) {
                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            } else {
                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            }

            this.winPaylineGoToCase(i, Payline.CaseFirstWin);
        }
    }

    protected finishFirstInitWins(): void {
        if (this.currentWins.length > 0) {
            if (this.currentWins.length > 1) {
                //if scatter win, we get 2 wins (cash, fs) - still single win
                if (
                    this.currentWins[0].trigger == Communication.Game.WinTrigger.Scatter &&
                    this.currentWins.length == 2
                ) {
                    this.winSymbolsGoToCase(0, Symbol.CaseWin, true);
                    PlayList.play("SND_BaseRecapWinline");

                    if (!ModuleManager.freespinsEnabled() && !ModuleManager.freespinsActive()) {
                        PlayList.loop("SND_BaseRecapLoop");
                    }

                    return;
                }

                this.stopTimer();
                this.currentCycle = 0;
                this.cycleWins(true);
            } else {
                this.winSymbolsGoToCase(0, Symbol.CaseWin, true);
                PlayList.play("SND_BaseRecapWinline");

                if (!ModuleManager.freespinsEnabled() && !ModuleManager.freespinsActive()) {
                    PlayList.loop("SND_BaseRecapLoop");
                }
            }
        }
    }

    protected cycleWins(isFirst: boolean = false): void {
        if (this.currentWins == null) {
            return;
        }

        if (ModuleManager.freespinsActive()) {
            if (FreespinsView.ReelsFrame !== null) {
                if (this.currentWins[this.currentCycle].payoutId === 10) {
                    if (FreespinsView.ReelsFrame.getCurrentCase() !== "NORMAL") {
                        FreespinsView.ReelsFrame.goToCase("TO_NORMAL");
                    }
                } else {
                    if (FreespinsView.ReelsFrame.getCurrentCase() !== "CYCLE_WIN") {
                        FreespinsView.ReelsFrame.goToCase("CYCLE_WIN");
                    }
                }
            }
        } else if (!ModuleManager.freespinsEnabled()) {
            if (BaseView.ReelsFrame !== null && BaseView.ReelsFrame.getCurrentCase() !== "CYCLE_WIN") {
                BaseView.ReelsFrame.goToCase("CYCLE_WIN");
            }
        }

        this.customWildBackground(this.currentCycle);

        //skip freespin cycle win
        if (this.currentWins[this.currentCycle].type === Communication.Game.WinType.freeSpins) {
            this.currentCycle = (this.currentCycle + 1) % this.currentWins.length;
            this.cycleWins(isFirst);

            return;
        }

        PlayList.play("SND_BaseWinline");
        this.playWildSoundsInLine(this.currentCycle);

        for (let i = 0; i < this.currentWins.length; i++) {
            if (i == this.currentCycle) {
                this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);
            } else {
                this.winSymbolsGoToCase(i, Symbol.CaseNormal, true);
            }
        }
        this.reAppendSymbolsInCycle(this.currentCycle);
        super.cycleWins(isFirst);
    }

    protected winSymbolsGoToCase(winIndex: number, caseType: string, useValue: boolean): void {
        if (this.currentWins[winIndex].trigger === Communication.Game.WinTrigger.Scatter) {
            super.winSymbolsGoToCase(winIndex, caseType, false);
        } else {
            super.winSymbolsGoToCase(winIndex, caseType, useValue);
        }
    }

    protected winSymbolsGoToCaseAsPayline(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        if (this.paylines != null) {
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                win.paylineId,
                this.paylines.paylineDefinition,
            );

            for (let i = 0; i < definition.length; i++) {
                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
                    const symbol = this.currentSymbols[i][definition[i]];

                    let caseTypeCustom: string = Symbol.CaseWin + "_" + i;
                    if (caseType === Symbol.CaseCycle) {
                        caseTypeCustom = Symbol.CaseCycle + "_" + i;
                    }

                    if (caseType === Symbol.CaseWin || caseType === Symbol.CaseCycle) {
                        if (symbol.hasCase(caseTypeCustom)) {
                            symbol.goToCase(caseTypeCustom);
                        } else {
                            symbol.goToCase(caseType);
                        }
                    } else {
                        symbol.goToCase(caseType);
                    }

                    this.symbolsContainer.addChild(symbol);

                    symbols.push(symbol);
                }
            }
        }

        return symbols;
    }

    protected allSymbolsGoToCase(caseType: string, noWin: boolean): void {
        for (let i = 0; i < this.currentSymbols.length; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                const symbol = this.currentSymbols[i][j];

                if (symbol !== null && this.allowSymbolGoToCase(i, j, caseType)) {
                    if (caseType === Symbol.CaseNormal && symbol.getCurrentCase() === Symbol.CaseIdle) {
                    } else {
                        symbol.goToCase(caseType);

                        if (noWin) {
                            this.noWinSymbolsContainer.addChild(symbol);
                        } else {
                            this.symbolsContainer.addChild(symbol);
                        }
                    }
                }
            }
        }
    }

    protected addCurrentSymbol(reelIndex: number, symbolIndex: number): void {
        if (this.currentSymbols[reelIndex][symbolIndex] === null) {
            const id = this.currentReels[reelIndex].symbols[symbolIndex];
            let value = 0;
            let value2 = 0;
            if (
                this.currentReels[reelIndex].customData != null &&
                this.currentReels[reelIndex].customData["scatterValues"] != null
            ) {
                value = this.currentReels[reelIndex].customData["scatterValues"][symbolIndex];
            }
            if (
                this.currentReels[reelIndex].customData != null &&
                this.currentReels[reelIndex].customData["scatterSymbolValues"] != null
            ) {
                value = this.currentReels[reelIndex].customData["scatterSymbolValues"][symbolIndex];
            }
            if (
                this.currentReels[reelIndex].customData != null &&
                this.currentReels[reelIndex].customData["extraScatterMultipliers"] != null
            ) {
                value2 = this.currentReels[reelIndex].customData["extraScatterMultipliers"][symbolIndex];
            }

            const symbol = this.symbols.getSymbol(id - 1, Symbol.CaseNormal);
            if (Symbol.Teas && symbol.id < 8) {
                symbol.goToCase(Symbol.CaseNowin);
            }
            if (symbol.id < 9) {
                symbol.setFinalAmount(value);
            } else {
                symbol.setFinalMultiplier(value2);
                symbol.setFinalAmountHidden(value);
            }
            symbol.position.x = this.reelX[reelIndex] - symbol.offsetX;
            symbol.position.y = this.reelY[reelIndex] + this.symbolHeight * symbolIndex - symbol.offsetY;

            this.symbolsContainer.addChild(symbol);

            this.currentSymbols[reelIndex][symbolIndex] = symbol;
        }
    }

    protected winSymbolsGoToCaseAsScatter(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        for (let i = 0; i < this.reelCount; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                if ((win.mask[i] & (1 << j)) !== 0 && this.allowSymbolGoToCase(i, j, caseType)) {
                    const symbol = this.currentSymbols[i][j];
                    symbol.goToCase(caseType);
                    if (win.payoutId === 9) {
                        if (symbol.id === 9) {
                            symbol.setFinalAmount(win.amount);
                        }
                    }

                    this.symbolsContainer.addChild(symbol);

                    symbols.push(symbol);
                }
            }
        }

        return symbols;
    }

    public reset(showLastSymbols: boolean): boolean {
        this.wasExtraScatters = false;
        this.scatterFsSymbols = [];
        this.scatterFsSymbolsValues = [];
        this.resetAmountsOnSymbols();
        return super.reset(showLastSymbols);
    }

    private reAppendSymbols(): void {
        // if(this.currentWins != null && this.currentWins.length > 0) {
        //     let lastReel: number = 0;
        //     for(let i: number = 0; i < this.currentWins.length; i++) {
        //         if(this.currentWins[i] != null && this.currentWins[i].mask != null && this.currentWins[i].mask.length > 0) {
        //             for(let j: number = 0; j < this.currentWins[i].mask.length; j++) {
        //                 if(this.currentWins[i].mask[j] > 0) {
        //                     if(lastReel <= j) {
        //                         lastReel = j;
        //                     }
        //                 }
        //             }
        //         }
        //     }
        //     for(let i: number = 0; i <= lastReel; i++) {
        //         if(this.symbolsContainer != null) {
        //             for(let j: number = 0; j < 3; j++) {
        //                 if(this.currentSymbols[i][j] != null) {
        //                     this.symbolsContainer.addChild(this.currentSymbols[i][j]);
        //                 }
        //             }
        //         }
        //     }
        // }
    }

    private reAppendSymbolsInCycle(i: number): void {
        // if(this.currentWins != null && this.currentWins.length > 0) {
        //     let lastReel: number = 0;
        //     if(this.currentWins[i] != null && this.currentWins[i].mask != null && this.currentWins[i].mask.length > 0) {
        //         for(let j: number = 0; j < this.currentWins[i].mask.length; j++) {
        //             if(this.currentWins[i].mask[j] > 0) {
        //                 if(lastReel <= j) {
        //                     lastReel = j;
        //                 }
        //             }
        //         }
        //     }
        //     for(let i: number = 0; i < 5; i++) {
        //         if(i <= lastReel) {
        //             if(this.symbolsContainer != null) {
        //                 for(let j: number = 0; j < 3; j++) {
        //                     if(this.currentSymbols[i][j] != null) {
        //                         this.symbolsContainer.addChild(this.currentSymbols[i][j]);
        //                     }
        //                 }
        //             }
        //         } else {
        //             if(this.noWinSymbolsContainer != null) {
        //                 for(let j: number = 0; j < 3; j++) {
        //                     if(this.currentSymbols[i][j] != null) {
        //                         this.noWinSymbolsContainer.addChild(this.currentSymbols[i][j]);
        //                     }
        //                 }
        //             }
        //         }
        //     }
        //     this.emit('ReapendReels' + lastReel);
        // }
    }

    private customTints(): void {
        // for(let i: number = 0; i < 20; i++) {
        //     if(this.currentWins != null && this.currentWins[i] != null) {
        //         if(this.currentWins[i].paylineId != null) {
        //             switch (this.currentWins[i].payoutId) {
        //                 case 1:
        //                     ImageElement.CustomTints['Line' + this.currentWins[i].paylineId] = 0xff0000;
        //                     break;
        //                 case 2:
        //                     ImageElement.CustomTints['Line' + this.currentWins[i].paylineId] = 0xffde00;
        //                     break;
        //                 case 3:
        //                     ImageElement.CustomTints['Line' + this.currentWins[i].paylineId] = 0xff5800;
        //                     break;
        //                 case 4:
        //                     ImageElement.CustomTints['Line' + this.currentWins[i].paylineId] = 0x0080ff;
        //                     break;
        //                 case 5:
        //                     ImageElement.CustomTints['Line' + this.currentWins[i].paylineId] = 0xd700ff;
        //                     break;
        //                 case 6:
        //                     ImageElement.CustomTints['Line' + this.currentWins[i].paylineId] = 0x37ff00;
        //                     break;
        //                 case 7:
        //                     ImageElement.CustomTints['Line' + this.currentWins[i].paylineId] = 0xbc0000;
        //                     break;
        //                 default:
        //                     ImageElement.CustomTints['Line' + this.currentWins[i].paylineId] = 0xffffff;
        //             }
        //         }
        //     }
        // }
    }

    private customWildBackground(index: number = null): void {
        if (index == null) {
            if (this.currentWins != null && this.currentWins[0] != null && this.currentWins[0].payoutId != null) {
                let payoutId: number = this.currentWins[0].payoutId;
                let canUse: boolean = true;
                for (let i: number = 0; i < this.currentWins.length; i++) {
                    if (this.currentWins[i].payoutId !== payoutId) {
                        canUse = false;
                    }
                }
                if (canUse) {
                    SwitchElement.CustomCase = "BACKGROUND_" + payoutId;
                } else {
                    SwitchElement.CustomCase = "BACKGROUND_0";
                }
            }
        } else {
            if (this.currentWins[index] != null) {
                SwitchElement.CustomCase = "BACKGROUND_" + this.currentWins[index].payoutId;
            }
        }
    }

    private playWildSounds(): void {
        let playWildSound: boolean = false;
        if (this.currentWins != null) {
            for (let i: number = 0; i < this.currentWins.length; i++) {
                if (!playWildSound) {
                    if (this.currentWins[i] != null && this.currentWins[i].symbols != null) {
                        for (let j: number = 0; j < this.currentWins[i].symbols.length; j++) {
                            if (this.currentWins[i].symbols[j] === 8) {
                                if (!playWildSound) {
                                    PlayList.play("SND_wildWin");
                                    playWildSound = true;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    private playWildSoundsInLine(index: number): void {
        let playWildSound: boolean = false;
        if (this.currentWins[index] != null && this.currentWins[index].symbols != null) {
            for (let j: number = 0; j < this.currentWins[index].symbols.length; j++) {
                if (this.currentWins[index].symbols[j] === 8) {
                    if (!playWildSound) {
                        PlayList.play("SND_wildWin");
                        playWildSound = true;
                    }
                }
            }
        }
    }

    public fixFeatureValue(): void {
        if (
            BaseView.FeatureValues != null &&
            GameManager.baseResponse != null &&
            GameManager.baseResponse.customData != null &&
            GameManager.baseResponse.customData["scatterValue"]
        ) {
            let amount: ImageTextElement = BaseView.FeatureValues.getChildElementByName("Amount") as ImageTextElement;
            amount.bitmapText.text =
                Languages.formatText(Languages.FormatMoney, GameManager.baseResponse.customData["scatterValue"]) + "";
            amount.realign();
        }
    }

    public checkScatters(wins: Array<Communication.Game.IWin>, win: number): boolean {
        this.oldBaseValue = "0";
        this.specialValue = "0";
        this.currentWins = wins;
        this.currentWin = win;
        this.scatterWin = null;
        this.scatterCounter = 0;
        this.scatterSymbols = [];

        for (let i: number = 0; i < wins.length; i++) {
            if (wins[i].trigger === Communication.Game.WinTrigger.Scatter && wins[i].payoutId === 8) {
                this.scatterWin = wins[i];
            }
        }

        if (this.scatterWin != null) {
            if (BaseView.FeatureValues != null) {
                BaseView.FeatureValues.goToCase("START");
                let amount: ImageTextElement = BaseView.FeatureValues.getChildElementByName(
                    "Amount",
                ) as ImageTextElement;
                amount.bitmapText.text = "";
                amount.realign();
                let plus: ImageTextElement = BaseView.FeatureValues.getChildElementByName("Plus") as ImageTextElement;
                plus.bitmapText.text = "";
                plus.realign();
                let amount2: ImageTextElement = BaseView.FeatureValues.getChildElementByName(
                    "Amount2",
                ) as ImageTextElement;
                amount2.bitmapText.text = "";
                amount2.realign();
            }
            if (BaseView.Logo != null) BaseView.Logo.goToCase("TO_FS");

            this.allSymbolsGoToCase(Symbol.CaseNowin, true);
            for (let i = 0; i < this.reelCount; i++) {
                for (let j = 0; j < this.symbolCount; j++) {
                    if ((this.scatterWin.mask[i] & (1 << j)) !== 0) {
                        const symbol = this.currentSymbols[i][j];
                        symbol.goToCase("BUZZER");
                        this.symbolsContainer.addChild(symbol);
                        this.scatterSymbols.push(symbol);
                    }
                }
            }
            // PlayList.play('SND_BaseFSTeaserWin');
            PlayList.play("SND_Buzzer");
            this.scatter.start(180);
            return true;
        } else {
            return false;
        }
    }

    public checkFSScatters(retrigger: boolean): boolean {
        this.scatterCounter = 0;
        this.scatterFsSymbols = [];
        this.scatterFsSymbolsValues = [];
        for (let i = 0; i < this.currentSymbols.length; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                if (this.currentSymbols[i][j].id === 8) {
                    this.scatterFsSymbols.push(this.currentSymbols[i][j]);
                    this.scatterFsSymbolsValues.push(this.currentSymbols[i][j].amount);
                }
            }
        }

        // this.allSymbolsGoToCase(Symbol.CaseNowin, true);
        if (this.currentSymbols != null) {
            for (let i: number = 0; i < this.currentSymbols.length; i++) {
                for (let j: number = 0; j < this.currentSymbols[i].length; j++) {
                    if (this.currentSymbols[i][j].id === 8 || this.currentSymbols[i][j].id === 9) {
                        this.symbolsContainer.addChild(this.currentSymbols[i][j]);
                        if (this.currentSymbols[i][j].id === 9) {
                            this.currentSymbols[i][j].hideFinalAmount();
                            this.currentSymbols[i][j].goToCase("NORMAL");
                        } else {
                            if (retrigger) {
                                this.currentSymbols[i][j].goToCase("BUZZER");
                            } else {
                                this.currentSymbols[i][j].goToCase("NORMAL");
                                this.currentSymbols[i][j].showFinalAmount();
                            }
                        }
                    } else {
                        this.currentSymbols[i][j].goToCase("NOWIN");
                    }
                }
            }
        }

        if (this.scatterFsSymbols.length > 0) {
            if (retrigger) {
                PlayList.play("SND_Buzzer");
                this.scatterFS.start(180);
            } else {
                this.scatterFS.start(15);
            }
            return true;
        } else {
            return false;
        }
    }

    public checkExtraScatters(wins: Array<Communication.Game.IWin>, win: number): boolean {
        this.wasExtraScatters = false;
        this.currentWins = wins;
        this.currentWin = win;
        this.extraScatterSymbols = [];
        this.extraScatterCounter = 0;

        for (let i = 0; i < this.currentSymbols.length; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                if (this.currentSymbols[i][j].id === 9) {
                    this.extraScatterSymbols.push(this.currentSymbols[i][j]);
                }
            }
        }

        if (this.extraScatterSymbols.length > 0) {
            if (this.currentSymbols != null) {
                for (let i: number = 0; i < this.currentSymbols.length; i++) {
                    for (let j: number = 0; j < this.currentSymbols[i].length; j++) {
                        if (this.currentSymbols[i][j].id === 8 || this.currentSymbols[i][j].id === 9) {
                            this.symbolsContainer.addChild(this.currentSymbols[i][j]);
                            if (this.currentSymbols[i][j].id === 9) {
                                this.currentSymbols[i][j].hideFinalAmount();
                                this.currentSymbols[i][j].goToCase("START");
                            } else {
                                this.currentSymbols[i][j].goToCase("NORMAL");
                            }
                        } else {
                            this.currentSymbols[i][j].goToCase("NOWIN");
                        }
                    }
                }
            }
            PlayList.play("SND_BaseWin01");
            this.extraScatter.start(90);
            return true;
        } else {
            return false;
        }
    }

    private onScatter(): void {
        if (this.scatterSymbols[this.scatterCounter] != null) {
            if (
                this.scatterSymbols[this.scatterCounter].amount != null &&
                this.scatterSymbols[this.scatterCounter].amount > 0
            ) {
                PlayList.play("SND_FSScatterWin0" + this.scatterCounter);
                this.oldBaseValue = Languages.formatText(
                    Languages.FormatMoney,
                    NumberUtils.add(parseFloat(this.oldBaseValue), this.scatterSymbols[this.scatterCounter].amount),
                );

                if (BaseView.FeatureValues != null) {
                    BaseView.FeatureValues.goToCase("POP");
                    let amount: ImageTextElement = BaseView.FeatureValues.getChildElementByName(
                        "Amount",
                    ) as ImageTextElement;
                    amount.bitmapText.text = this.oldBaseValue + "";
                    amount.realign();
                }

                this.scatterSymbols[this.scatterCounter].goToCase("REVEAL");
                this.scatterCounter++;
                this.emit("ScatterPop");
                this.scatter.start(30);
            }
        } else {
            this.emit("ScatterFinished");
        }
    }

    private onFSScatter(): void {
        if (this.scatterFsSymbols[this.scatterCounter] != null) {
            if (
                this.scatterFsSymbols[this.scatterCounter].amount != null &&
                this.scatterFsSymbols[this.scatterCounter].amount > 0
            ) {
                PlayList.play("SND_FSScatterWin0" + this.scatterCounter);
                if (BaseView.FeatureValues != null) {
                    this.specialValue = Languages.formatText(
                        Languages.FormatMoney,
                        NumberUtils.add(
                            parseFloat(this.specialValue),
                            this.scatterFsSymbols[this.scatterCounter].amount,
                        ),
                    );
                    BaseView.FeatureValues.goToCase("POP");
                    let plus: ImageTextElement = BaseView.FeatureValues.getChildElementByName(
                        "Plus",
                    ) as ImageTextElement;
                    plus.bitmapText.text = "+";
                    plus.realign();
                    let amount2: ImageTextElement = BaseView.FeatureValues.getChildElementByName(
                        "Amount2",
                    ) as ImageTextElement;
                    amount2.bitmapText.text = this.specialValue + "";
                    amount2.realign();
                }
                this.scatterFsSymbols[this.scatterCounter].goToCase("COUNT_PLUS");
                this.scatterCounter++;
                this.scatterFS.start(30);
            }
        } else {
            // TODO update values
            this.emit("ScatterFinished");
        }
    }

    private onExtraScatter(): void {
        this.wasExtraScatters = true;
        if (this.extraScatterSymbols[this.extraScatterCounter] != null) {
            if (BaseView.FeatureValues != null) {
                PlayList.play("SND_FSCount");
                BaseView.FeatureValues.goToCase("POP");
            }
            this.extraScatterSymbols[this.extraScatterCounter].goToCase("REVEAL");
            this.extraScatterCounter++;
            this.extraScatterSound.start(30);
            this.extraScatterSound1.start(60);
            this.extraScatter.start(90);
        } else {
            if (BaseView.FeatureValues != null && this.specialValue !== "0") {
                this.specialValue = "0";
                BaseView.FeatureValues.goToCase("POP");
                let plus: ImageTextElement = BaseView.FeatureValues.getChildElementByName("Plus") as ImageTextElement;
                plus.bitmapText.text = "";
                plus.realign();
                let amount2: ImageTextElement = BaseView.FeatureValues.getChildElementByName(
                    "Amount2",
                ) as ImageTextElement;
                amount2.bitmapText.text = "";
                amount2.realign();
            }
            this.emit("ExtraScatterFinished");
        }
    }

    private onExtraScatterSound(): void {
        PlayList.play("SND_FSScarabCount");
    }

    private onExtraScatterSound1(): void {
        PlayList.play("SND_FSExtraScatterWin0" + (this.extraScatterCounter - 1));
    }

    private resetAmountsOnSymbols() {
        if (this.currentSymbols != null) {
            for (let i: number = 0; i < this.currentSymbols.length; i++) {
                for (let j: number = 0; j < this.currentSymbols[i].length; j++) {
                    this.currentSymbols[i][j].switchAmounts(false);
                }
            }
        }
    }

    protected moveToTop(): void {
        for (let i = 0; i < this.currentSymbols.length; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                const symbol = this.currentSymbols[i][j];
                if (symbol !== null && symbol.id === 8) {
                    symbol.parent.addChild(symbol);
                }
            }
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                const symbol = this.currentSymbols[i][j];
                if (symbol !== null && symbol.id === 9) {
                    symbol.parent.addChild(symbol);
                }
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimator2.ts
 **/